import { Tooltip } from 'react-tooltip'
import clsx from 'clsx'

interface Props {
	data: {
		title: string
		features: {
			key: string
			title: string
			tooltip?: string
			standard: {
				status: boolean
				word: string | null
			}
			business: {
				status: boolean
				word: string | null
			}
			enterprise: {
				status: boolean
				word: string | null
			}
		}[]
	}[]
}

const PricingPlan: React.FC<Props> = ({ data }) => {
	return (
		<div id="features-table">
			<div className="row">
				{data.map(plan => (
					<div key={`feature-${plan.title}`} className="col-12 mb-5">
						<div className="row px-0">
							<div className="col-12 text-kumopack-primary-700" id="plan-title">
								{plan.title}
							</div>

							{(plan.features ?? []).map((feature, idx) => (
								<div key={`feature-${feature.key}`} className="col-12">
									<div className="row px-0" id="table-row">
										<div
											id="feature-title"
											className={clsx('text-kumopack-grey-900 pe-0', {
												'bg-kumopack-grey-50': idx % 2 === 0,
											})}
											style={{ width: feature.tooltip ? '35.4%' : '37.4%' }}>
											{feature.title}
										</div>
										{feature.tooltip && (
											<>
												<div
													className={clsx('px-0', {
														'bg-kumopack-grey-50': idx % 2 === 0,
													})}
													style={{ width: '2%' }}>
													<img
														id={feature.key}
														className="cursor-pointer w-20px"
														src="/media/icons/kumopack/help-circle.svg"
														alt="Help Tooltip Icon"
													/>

													<Tooltip
														noArrow
														anchorSelect={`#${feature.key}`}
														place="top"
														style={{ zIndex: 5 }}>
														{feature.tooltip}
													</Tooltip>
												</div>
											</>
										)}
										{/* Standard */}

										<div
											id="feature-value"
											className={clsx('col-2 text-kumopack-grey-600 text-center', {
												'bg-kumopack-grey-50': idx % 2 === 0,
											})}
											style={{ width: '20.86%' }}>
											{feature.standard.status ? (
												feature.standard.word ? (
													feature.standard.word
												) : (
													<img
														src="/media/icons/kumopack/green-check-circle.svg"
														alt="Green Check Circle"
													/>
												)
											) : (
												<img src="/media/icons/kumopack/grey-minus.svg" alt="Grey Minus Icon" />
											)}
										</div>

										{/* Business */}

										<div
											id="feature-value"
											className={clsx('col-2 text-kumopack-grey-600 text-center', {
												'bg-kumopack-grey-50': idx % 2 === 0,
											})}
											style={{ width: '20.86%' }}>
											{feature.business.status ? (
												feature.business.word ? (
													feature.business.word
												) : (
													<img
														src="/media/icons/kumopack/green-check-circle.svg"
														alt="Green Check Circle"
													/>
												)
											) : (
												<img src="/media/icons/kumopack/grey-minus.svg" alt="Grey Minus Icon" />
											)}
										</div>

										{/* Enterprise */}

										<div
											id="feature-value"
											className={clsx('col-2 text-kumopack-grey-600 text-center', {
												'bg-kumopack-grey-50': idx % 2 === 0,
											})}
											style={{ width: '20.86%' }}>
											{feature.enterprise.status ? (
												feature.enterprise.word ? (
													feature.enterprise.word
												) : (
													<img
														src="/media/icons/kumopack/green-check-circle.svg"
														alt="Green Check Circle"
													/>
												)
											) : (
												<img src="/media/icons/kumopack/grey-minus.svg" alt="Grey Minus Icon" />
											)}
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default PricingPlan
